export const VIEW_MODE = {
  creation: 'creation',
  editing: 'editing',
};

export const MULTILINE_ROWS_LIMIT_SINGLE_FIELD = 10;
export const MULTILINE_ROWS_LIMIT_SECOND_FIELD = 6;
export const MULTILINE_ROWS_SECOND_FIELD = 4;
export const WTM_MULTILINE_ROWS_SECOND_FIELD = 10;
export const MULTILINE_ROWS_FIELD = 16;

export const DEFAULT_INPUT_PROPS = {
  // Do not propagate "keydown" events up, so 'Enter' won't cause 'Next' click if used in HTML "form"
  onKeyDown: (event) => {
    event.stopPropagation();
  },
};
